<script setup>
import { defineProps, defineEmits, toRaw } from 'vue'
import sensor from '@utils/saUtilsGlobal'

const props = defineProps({
  cardContent: {
    type: Object,
    default: () => {}
  },
  isRTL: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['previewImage'])
const linkUrl = `https://www.google.com/maps?q=${props.cardContent.lat},${props.cardContent.lng}`

// 点击地址或者经纬度上报埋点信息
const handleClickLink = (record) => {
  if (Number(record.id) === 2) {
    handleTrack('address')
  }
  if (Number(record.id) === 3) {
    handleTrack('coordinate')
  }
}

const handlePreview = () => {
  emits('previewImage', props.cardContent)
}

/**
 * 上报埋点信息
 * */
const handleTrack = (clickItem, params) => {
  sensor.track('H5_click_page_pdf_link', {
    clickItem,
    ...params
  })
}
</script>

<template>
  <div class="content-wrapper">
    <div class="card-image" @click="handlePreview">
      <div class="leftTopIcon">
        <img src="../assets/left_top_icon.png" alt="" />
      </div>
      <img
        :src="props.cardContent.thumbnail"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </div>
    <div
      class="card-text"
      :style="{ marginRight: props.isRTL ? '10px' : undefined }"
    >
      <template v-for="(item, index) in props.cardContent.list" :key="index">
        <div class="text-wrapper">
          <div class="textTitle">{{ item.title }}</div>
          <div
            @click="handleClickLink(toRaw(item))"
            class="textContent"
            v-if="Number(item.id) === 2 || Number(item.id) === 3"
          >
            <a :href="linkUrl" target="_blank">{{ item.content }}</a>
          </div>
          <div class="textContent" v-else>
            {{ item.content }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-wrapper {
  display: flex;
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }

  .card-image {
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;

    .leftTopIcon {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 24px;
      height: 24px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 16px;
        height: 16px;
      }
    }

    @media (min-width: 768px) {
      width: 217px;
      height: 290px;
      background: #f0f0f0;
      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }

    @media (max-width: 768px) {
      // 移动端图片的宽高
      display: flex;
      background: #f0f0f0;
      width: 132px;
      height: 176px;
      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
  }
  .card-text {
    overflow: hidden;

    @media (min-width: 768px) {
      height: 290px;
      .text-wrapper {
        margin: 0 0 14px 16px;

        .textTitle {
          font-weight: 600;
          font-size: 12px;
          line-height: 16px;
        }

        .textContent {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }

    @media (max-width: 768px) {
      height: 176px;
      .text-wrapper {
        margin: 0 0 14px 16px;

        .textTitle {
          font-weight: 700;
          font-size: 12px;
          line-height: 14px;
        }

        .textContent {
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
  }
}
</style>
